import { Pipe, PipeTransform } from '@angular/core';

const unitMap = {
    kB: 1,
    MB: 2
};

@Pipe({
    name: 'byteConvert',
    standalone: true
})
export class ByteConvertPipe implements PipeTransform {
    transform(bytes?: number, unit?: 'kB' | 'MB'): string {
        if (isNaN(parseFloat(String(bytes)))) {
            return '?';
        }

        if (!unit || !(unit in unitMap)) {
            return '?';
        }

        const divisor = Math.pow(1024, unitMap[unit]);

        return `${((bytes || 0) / divisor).toFixed(2)} ${unit}`;
    }
}
